import InfoIcon from '@/fo/icons/base/icons/info.svg';
import { UiKitPriceBase } from '@/fo/ui/kit/price/base';
import { UiKitTooltipBase } from '@/fo/ui/kit/tooltip/base';
import { UiLoyaltyLabelBase } from '@/fo/ui/loyalty/label/base';

import { OrderSummaryItems } from './lib/UiOrderSummaryCompact';

export const items: OrderSummaryItems[] = [
  {
    label: <span className="heading-s">7 товаров</span>,
    value: (
      <UiKitPriceBase
        value={19659}
        classNameValue="max-xs:heading-s-bold heading-m-bold"
      />
    )
  },
  {
    label: <span className="heading-s">Скидка</span>,
    value: (
      <UiKitPriceBase
        value={1716}
        classNameValue="max-xs:heading-s-bold heading-m-bold"
      />
    )
  },
  {
    label: <span className="heading-s">Доставка</span>,
    value: (
      <span className="max-xs:heading-s-bold heading-m-bold">Бесплатно</span>
    )
  },
  {
    label: (
      <span className="heading-s flex items-center gap-2">
        Баллы за заказ{' '}
        <UiKitTooltipBase
          side="bottom"
          content={
            <div className="heading-xs max-w-[320px]">
              Мы зачислим ваши баллы, как только заказ будет доставлен
            </div>
          }
        >
          <InfoIcon className="text-icon-secondary" />
        </UiKitTooltipBase>
      </span>
    ),
    value: (
      <UiLoyaltyLabelBase
        points={1000}
        sign="plus"
      />
    )
  }
];
